import { observable } from "mobx";
import { getDeep } from "@citychallenge/common";

export class Translation {
  @observable
  public value!: string;

  public setValue(value: string) {
    this.value = value;
    this._refreshTokens();
  }

  public tokens: { re: string; token: string }[] = [];

  private _refreshTokens() {
    this.tokens = [];
    const regex = /{{([\w\.-]+)}}/g;
    let result: RegExpExecArray | null;

    while ((result = regex.exec(this.value))) {
      this.tokens.push({
        re: result[1].replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
        token: result[1],
      });
    }
  }

  constructor(public readonly key: string, value: string) {
    this.setValue(value);
  }

  public interpolate(values?: { [key: string]: any }) {
    let value = this.value;

    for (const { re, token } of this.tokens) {
      const regex = new RegExp(`{{${re}}}`, "g");

      const replacement: Translation | string | undefined = getDeep(
        values,
        token
      );

      const interpolatedRepl =
        replacement instanceof Translation
          ? replacement.interpolate(values)
          : replacement;

      // A callback, so a value containing `$&`-style patterns is inserted
      // verbatim rather than read as a replacement pattern.
      const text =
        interpolatedRepl !== undefined ? String(interpolatedRepl) : "";
      value = value.replace(regex, () => text);
    }

    return value;
  }
}

export function trans(
  token: undefined | string | Translation,
  values?: Record<string, any>
) {
  if (!(token instanceof Translation)) return token;

  return token.interpolate(values);
}
